import type { BookmarkPayload } from "./types";

export const generateNewList = (list: string[] | undefined, payload: BookmarkPayload) => {
  list = list ?? [];
  return payload.action === "bookmark"
    ? [...list, payload.id]
    : list?.filter(id => id !== payload.id);
};
